  <div class="clearfix position-relative">
    <div class="row">
      <div class="col-12 text-center mt-4" *ngFor="let doc_for of listData?.document_for">
        <div class="float-left">
          <img [src]="doc_for?.logo" onerror="this.src='assets/themes/icons/association-placeholder.svg';" class="img-size rounded-circle post-pic" />
          
        </div>
        <div class="mt-3 ml-3 paragraph-bold float-left">
          <p>{{doc_for?.name}}</p>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <p class="secondary-paragraph mt-3 mb-2 clearfix"><span class="color-grey-500">{{listData?.required_details?.input_type?.doc_name}}</span>
       <span
        (mouseenter)="infomrn=!infomrn" (mouseleave)="infomrn=!infomrn" class="float-right"
        [ngClass]="{'cursor-pointer': listData?.required_details?.input_type?.example_url!='' && listData?.required_details?.input_type?.example_url!=null}">
        <img src="assets/themes/icons/info-icon.svg" alt="report"/>
      </span>
    </p>
    <div
      *ngIf="infomrn==true && listData?.required_details?.input_type?.example_url!='' && listData?.required_details?.input_type?.example_url!=null"
      id="cardmrn" class="common-dropdown-list bg-white position-absolute required-dtls d-block w-auto border p-2">
    
      <img  [src]="listData?.required_details?.input_type?.example_url"
        onerror="this.src='assets/themes/icons/mediaimg-placeholder.svg';" />
    </div>
    <span class="form-input">
    <input id="mrn_no" (keyup)="userdocInput($event)" (click)="mrnFocus.emit()" type="text" class="input-field"
      placeholder="{{mls.languageText.association_verification_screen.key6}} {{listData?.required_details?.input_type?.placeholder}}"
      [(ngModel)]="inputData.value" [readonly]="listData?.required_details?.is_verified==1" />
    </span>

    <p *ngIf="listData?.required_details?.is_document_required==0"><span
        class="primary-small"><span class="color-grey-500">{{mls.languageText.association_verification_screen.key4}}</span><span
          *ngIf="mls?.is_lskey_display==1">(association_verification_screen.key4)</span></span></p>
    <p class="color-error">{{error_msg}}</p>
    <label *ngIf="errObj!=undefined && errObj?.log_id==listData?.log_id" class="color-error">{{errObj?.err_msg}}</label>
    <label
      class="file-upload cursor-pointer mb-3 mt-3"
      for="{{listData?.document_for[0].id}}"
      >
      <div class="file-upload-box">
      <input 
        (click)="fileUpload.emit();"
        type="file" 
        (change)="onSelectFile($event)"
        class="d-none"  
        accept=" image/jpeg, image/png,image/webp, application/pdf"  />
      <span class="img-container">
      <img class="mr-2" src="assets/themes/images/upload-cam.svg" alt="upload"/>
     </span>
     <span class="primary-small">
       <span class="color-info-blue">{{mls.languageText.association_verification_screen.key2}}</span>
      <span *ngIf="mls?.is_lskey_display==1">(association_verification_screen.key2)</span>
     </span>
      </div>
    </label>

    <!-- upload preview -->

    <div *ngIf="upload_data.absolute_path!=''" class="position-relative university-preview mb-3 rounded">
      <a *ngIf="listData?.required_details?.is_verified!=1" class="upload-preview cursor-pointer"
        (click)="removeCollegeId()"><img src="assets/themes/icons/cancel-white.svg" /></a>
      <img [src]="upload_data?.absolute_path" onerror="this.src='assets/themes/icons/banner-placeholder.svg';"
        class="preview-uploaded" />
    </div>
    <!-- end upload preview -->
    <span  *ngIf="uploadFile_api_in_process==true"
      class="upload-preview-end spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <input class="d-none" id="{{listData?.document_for[0].id}}" (change)="onSelectFile($event)" name="college-id"
      type="file" (click)="fileUpload.emit();" [disabled]="listData?.required_details?.is_verified==1">
  </div>